import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { Redirect, useLocation } from "react-router-dom";

import { GET_AUTH_TOKEN } from "graphql/query/user-gql";
import {
    getAttachmentIdFromPath,
    getAttachmentLoginPath,
    getAttachmentLoginRedirect,
} from "utils/attachment-auth";

import { Authorization } from '../pages';


const Authentication = ({children}) => {

    const { data } = useQuery(GET_AUTH_TOKEN, { fetchPolicy: "cache-only" });
    const location = useLocation();

    const authToken  = (data !== undefined &&
                        data.authToken !== undefined &&
                        data.authToken !== false) ? data.authToken : false;

    const attachmentId = getAttachmentIdFromPath(location.pathname);

    if (!authToken && attachmentId !== null) {
        return <Redirect to={getAttachmentLoginPath(attachmentId)} />;
    }

    if (authToken && /^\/login\/?$/.test(location.pathname)) {
        return <Redirect to={getAttachmentLoginRedirect(location.search)} />;
    }

    return (
        <>
            { authToken ? children : <Authorization /> }
        </>
    );
};


export default Authentication;
